Object.defineProperty(exports,"__esModule",{value:true});var Positions=exports.Positions={left:'flex-start',right:'flex-end',center:'center'};